/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData model module.
 * @module model/LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData
 * @version 1.0
 */
class LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData {
    /**
     * Constructs a new <code>LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData</code>.
     * @alias module:model/LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData
     */
    constructor() { 
        
        LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData} The populated <code>LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData();

            if (data.hasOwnProperty('gameSessionNo')) {
                obj['gameSessionNo'] = ApiClient.convertToType(data['gameSessionNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('userType')) {
                obj['userType'] = ApiClient.convertToType(data['userType'], 'Number');
            }
            if (data.hasOwnProperty('campaignNo')) {
                obj['campaignNo'] = ApiClient.convertToType(data['campaignNo'], 'Number');
            }
            if (data.hasOwnProperty('usedPower')) {
                obj['usedPower'] = ApiClient.convertToType(data['usedPower'], 'Number');
            }
            if (data.hasOwnProperty('usedExtraPower')) {
                obj['usedExtraPower'] = ApiClient.convertToType(data['usedExtraPower'], 'Number');
            }
            if (data.hasOwnProperty('earnedXper')) {
                obj['earnedXper'] = ApiClient.convertToType(data['earnedXper'], 'Number');
            }
            if (data.hasOwnProperty('earnedPer')) {
                obj['earnedPer'] = ApiClient.convertToType(data['earnedPer'], 'Number');
            }
            if (data.hasOwnProperty('startedAt')) {
                obj['startedAt'] = ApiClient.convertToType(data['startedAt'], 'Date');
            }
            if (data.hasOwnProperty('endedAt')) {
                obj['endedAt'] = ApiClient.convertToType(data['endedAt'], 'Date');
            }
            if (data.hasOwnProperty('playTime')) {
                obj['playTime'] = ApiClient.convertToType(data['playTime'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('conditionBefore')) {
                obj['conditionBefore'] = ApiClient.convertToType(data['conditionBefore'], 'Number');
            }
            if (data.hasOwnProperty('conditionAfter')) {
                obj['conditionAfter'] = ApiClient.convertToType(data['conditionAfter'], 'Number');
            }
            if (data.hasOwnProperty('distanceDrivenBefore')) {
                obj['distanceDrivenBefore'] = ApiClient.convertToType(data['distanceDrivenBefore'], 'Number');
            }
            if (data.hasOwnProperty('distanceDrivenAfter')) {
                obj['distanceDrivenAfter'] = ApiClient.convertToType(data['distanceDrivenAfter'], 'Number');
            }
            if (data.hasOwnProperty('beforePower')) {
                obj['beforePower'] = ApiClient.convertToType(data['beforePower'], 'Number');
            }
            if (data.hasOwnProperty('afterPower')) {
                obj['afterPower'] = ApiClient.convertToType(data['afterPower'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} gameSessionNo
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['gameSessionNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['email'] = undefined;

/**
 * @member {Number} userType
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['userType'] = undefined;

/**
 * @member {Number} campaignNo
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['campaignNo'] = undefined;

/**
 * @member {Number} usedPower
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['usedPower'] = undefined;

/**
 * @member {Number} usedExtraPower
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['usedExtraPower'] = undefined;

/**
 * @member {Number} earnedXper
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['earnedXper'] = undefined;

/**
 * @member {Number} earnedPer
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['earnedPer'] = undefined;

/**
 * @member {Date} startedAt
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['startedAt'] = undefined;

/**
 * @member {Date} endedAt
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['endedAt'] = undefined;

/**
 * @member {Number} playTime
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['playTime'] = undefined;

/**
 * @member {Number} status
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['status'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} conditionBefore
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['conditionBefore'] = undefined;

/**
 * @member {Number} conditionAfter
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['conditionAfter'] = undefined;

/**
 * @member {Number} distanceDrivenBefore
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['distanceDrivenBefore'] = undefined;

/**
 * @member {Number} distanceDrivenAfter
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['distanceDrivenAfter'] = undefined;

/**
 * @member {Number} beforePower
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['beforePower'] = undefined;

/**
 * @member {Number} afterPower
 */
LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData.prototype['afterPower'] = undefined;






export default LogControllerDtoGamePlaySessionLogListGamePlaySessionLogData;

